import React from 'react';

import ComposerSettings from './ComposerSettings';

const MultiComposerSettings = props => <ComposerSettings {...props} />;

export default MultiComposerSettings;
